/**
 * @generated SignedSource<<aa0cf0380f8c683494ba508e41beb3e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FILTER_SECTION = "PROJECT" | "SCOPING" | "SPRINT" | "SPRINT_BACKLOG" | "WORKFLOW" | "SCHEDULING_PEOPLE" | "SCHEDULING_PROJECTS" | "SCHEDULING_PLACEHOLDERS" | "SCHEDULING_CAPACITY_OVERVIEW" | "MY_TASKS" | "MY_LIST" | "MY_WORK" | "MY_TIMESHEETS" | "PROJECTS_OVERVIEW" | "INVOICING_OVERVIEW" | "INVOICING_INVOICES" | "FINANCIAL_PORTFOLIO_REPORT" | "TEAM_TIMESHEET" | "TIME_APPROVAL" | "REPORTED_TIME_TABLE" | "PROJECT_TIMELINE" | "UTILIZATION_REPORT" | "TASK_REPORT" | "SKILLS" | "LABELS" | "OPPORTUNITIES" | "%future added value";
export type CreateFilterInput = {
  name?: string | null;
  value?: string | null;
  section?: FILTER_SECTION | null;
  projectId?: string | null;
  projectGroupId?: string | null;
  personId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createFilterMutation$variables = {
  input: CreateFilterInput;
};
export type createFilterMutation$data = {
  readonly createFilter: {
    readonly filter: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly section: FILTER_SECTION | null;
        readonly value: string | null;
        readonly updatedAt: string | null;
      } | null;
    } | null;
    readonly viewer: {
      readonly id: string;
    } | null;
  } | null;
};
export type createFilterMutation = {
  variables: createFilterMutation$variables;
  response: createFilterMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateFilterPayload",
    "kind": "LinkedField",
    "name": "createFilter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FilterTypeEdge",
        "kind": "LinkedField",
        "name": "filter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Filter",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "section",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createFilterMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createFilterMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e5a50668f48a16a222946dbe750db309",
    "id": null,
    "metadata": {},
    "name": "createFilterMutation",
    "operationKind": "mutation",
    "text": "mutation createFilterMutation(\n  $input: CreateFilterInput!\n) {\n  createFilter(input: $input) {\n    filter {\n      node {\n        id\n        name\n        section\n        value\n        updatedAt\n      }\n    }\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51fe904e61573d06eb12a9cab5305aa1";

export default node;
